import Consult from './src/main.vue';

/* istanbul ignore next */
Consult.install = function(Vue) {
  Vue.component(Consult.name, Consult);
};

export default Consult;
